import { LOADER } from '../actionTypes';

export const dataFetching = data => ({
  type: LOADER.FETCH_DATA,
  payload: {
    data
  }
});